// 基础类库，提供页面基本功能通过mixin 方式插入到该方法
/**
 * @author lei.you
 * 保存页面滚动条位置，并恢复到到滚动位置
 * */
import _ from 'lodash'
export default{
  created(){
    this.pos={
    };
  },

  updated(){
    var maxTry = 10;
    var i = 0;
    var timer = setInterval(e=>{
      var hasBind = this._bindScroll()
      if(hasBind){
        timer=clearInterval(timer);
      }else{
        i++;
        if(i>maxTry){
          clearInterval(timer);
        }
      }

    },1000);
  },
  mounted(){
    var maxTry = 10;
    var i = 0;
    var timer = setInterval(e=>{
      var hasBind = this._bindScroll();
      if(hasBind){
        timer=clearInterval(timer);
      }else{
        i++;
        if(i>maxTry){
          clearInterval(timer);
        }
      }

    },1000);

  },
  deactivated(){

  },
  activated(){
    this.$route.meta&&this.$route.meta.keepAlive&&(()=>{
      if(!_.isEmpty(this.pos)){
        var scrollDoms = document.getElementsByClassName("scrollKeep");
        if(scrollDoms.length>0){
          scrollDoms[0].scrollTop=this.pos.x;
        }
      }
    })()
  },
  methods:{
    _savePos( ){
      var scrollDoms = document.getElementsByClassName("scrollKeep");
      scrollDoms[0].removeEventListener("scroll",this._savePos);
      var x = scrollDoms[0].scrollTop;
      var pos={
        x:x
      }
      _.extend(this.pos,pos)
    },
    _bindScroll(){
      var self=this;
      var hasBind=false;
      this.$route.meta&&this.$route.meta.keepAlive&&(e=>{
        var scrollDoms = document.getElementsByClassName("scrollKeep");
        if(scrollDoms.length>0){
          scrollDoms[0].addEventListener("scroll",this._savePos.bind(this));
          hasBind=true;
        }
      })();
      return hasBind;
    },
  }
}
